/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-24 13:41:18
 */
import request from './request';
let base = process.env.BASE_URL;
// let base = '/prod'
/*          ******************************** */
export const GetpdfUrl = (params, self, config) => { return request.Post(`${base}/wx/wxLogin`, params, self, config) };
/*微信管理************************************************************************************************************************************** */
// 微信授权 
export const wxAuthorization = (parms, self, config) => { return request.Post(`${base}/wx/authorization`, parms, self, config) };
//微信token验证
export const checkToken = (parms, self, config) => { return request.Post(`${base}/wx/checkToken`, parms, self, config) };
//微信下单
export const weixinPay = (parms, self, config) => { return request.Post(`${base}/wx/weixinPay`, parms, self, config) };

/* end #################################################################################################### */
/*用户管理************************************************************************************************************************************** */
//短信验证
export const getCode = (parms, self, config) => { return request.Post(`${base}/user/getCode`, parms, self, config) };
// 获取所有检查项目和对应金额
export const getUserItem = (parms, self, config) => { return request.Post(`${base}/user/findItem`, parms, self, config) };
// 获取检查地址
export const getAddress = (parms, self, config) => { return request.Post(`${base}/user/findAddress`, parms, self, config) };

/*#################################################################################################### */
/*申请管理************************************************************************************************************************************** */
// 手机号查看申请列表(验证) @param{telephone(手机号),code(验证码)}
export const phonePassOrNot = (parms, self, config) => { return request.Post(`${base}/patient/phonePassOrNot`, parms, self, config) };
// 获取我的申请列表 @param{telephone(手机号),pageNum,pageSize}
export const getFindApplication = (parms, self, config) => { return request.Post(`${base}/patient/findApplication`, parms, self, config) };
// 查询具体某一条病例  @param{pid}
export const getFindByPid = (parms, self, config) => { return request.Post(`${base}/patient/findByPid`, parms, self, config) };
// 微信一键查询我的申请  @param{code}
export const getCheckWeChat = (parms, self, config) => { return request.Post(`${base}/patient/checkWeChat`, parms, self, config) };
// 根据单号查询报告  @param{code,orderNumber:订单号}
export const getFindReport = (parms, self, config) => { return request.Post(`${base}/patient/findReport`, parms, self, config) };
// 改变过程为计算中并添加时间  @param{pid}
export const updateProgress = (parms, self, config) => { return request.Post(`${base}/patient/updateProgress`, parms, self, config) };
// 修改支付结果 0:未支付; 1:支付成功  @param{pid,pid加密}
export const updateWhether = (parms, self, config) => { return request.Post(`${base}/patient/updateWhether`, parms, self, config) };
// 上传报告  @param{pid,uploadFile}
export const uploadReport = (parms, self, config) => { return request.Post(`${base}/patient/uploadReport`, parms, self, config) };
// 报告推送  @param{pid,pathPid}
export const pdfPush = (parms, self, config) => { return request.Post(`${base}/patient/pdfPush`, parms, self, config) };


/*#################################################################################################### */
/** 管理员接口 ************************************************************************************************************************************* */
// 上传报告  @param{phone,code}
export const AdminLogin = (parms, self, config) => { return request.Post(`${base}/admin/login`, parms, self, config) };
// 下拉框模糊查询  @param{data，fuzzyQueryType：NAME/TELEPHONE/HOSPITAL/PROGRESS/DOCTOR，pageNum，pageSize}
export const getFuzzyQueryt = (parms, self, config) => { return request.Post(`${base}/patient/fuzzyQuery`, parms, self, config) };

/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */
/*************************************************************************************************************************************** */
/*#################################################################################################### */


// WEBPACK FOOTER //
// ./src/api/api.js